export default __webpack_public_path__ + "static/media/circular-dolar-icon.8609c4bd.svg";